import LoginBySSOPage from "pages/LoginPage/LoginBySSOPage";
import { Route, Routes } from "react-router-dom";
import PluginGroupwareWebPage from "./PluginGroupwareWebPage";
import TaskGradingEditInvisiblePage from './TaskGradingEditInvisiblePage';
import TaskGradingEditVisiblePage from './TaskGradingEditVisiblePage';

export default function PluginGroupwareWebRouter() {
  return (
    <Routes>
      <Route path='' element={<PluginGroupwareWebPage />} />
      <Route path='login' element={<LoginBySSOPage />} />
      <Route path='open' element={<TaskGradingEditVisiblePage />} />
      <Route path='close' element={<TaskGradingEditInvisiblePage />} />
    </Routes>
  );
}
